import { blurText } from "../utils/blur_text";

const observerOptions = {
  rootMargin: "-20px 0px 0px 0px",
};

// media query
if (window.innerWidth < 768) {
  observerOptions.rootMargin = "-10px 0px 0px 0px";
}

if (document.querySelector(".v_singularity__container")) {
  blurText(".v_singularity__collaboratifs_section", observerOptions);
  blurText(".v_singularity__experts_section", observerOptions);
  blurText(".v_singularity__engages_section", observerOptions);
}
